export const defaultSlides = [
  {
    id: '0.1691686211006762',
    elements: [
      {
        type: 'text',
        version: 12,
        versionNonce: 756425576,
        isDeleted: false,
        id: 'jgi-TFa9cxbEF2rb9gI9m',
        fillStyle: 'cross-hatch',
        strokeWidth: 1,
        strokeStyle: 'solid',
        roughness: 1,
        opacity: 100,
        angle: 0,
        x: 535,
        y: 145,
        strokeColor: '#000000',
        backgroundColor: '#fa5252',
        width: 10,
        height: 25,
        seed: 2058795759,
        groupIds: [],
        fontSize: 20,
        fontFamily: 1,
        text: '',
        baseline: 18,
        textAlign: 'left',
        verticalAlign: 'top',
      },
      {
        type: 'text',
        version: 308,
        versionNonce: 1073039384,
        isDeleted: false,
        id: 'PNx4gwK93bE-4E8dJf3jU',
        fillStyle: 'hachure',
        strokeWidth: 1,
        strokeStyle: 'solid',
        roughness: 1,
        opacity: 100,
        angle: 0,
        x: 417.97265625,
        y: 88.8828125,
        strokeColor: '#000000',
        backgroundColor: 'transparent',
        width: 333,
        height: 90,
        seed: 241841647,
        groupIds: [],
        fontSize: 36,
        fontFamily: 1,
        text: 'Create your slides\nwith Excalidraw!',
        baseline: 77,
        textAlign: 'left',
        verticalAlign: 'top',
      },
      {
        type: 'arrow',
        version: 128,
        versionNonce: 2018342504,
        isDeleted: false,
        id: 'WMS16KQ15__gn5pnVJm9X',
        fillStyle: 'hachure',
        strokeWidth: 1,
        strokeStyle: 'solid',
        roughness: 1,
        opacity: 100,
        angle: 0,
        x: 1023.2421875,
        y: 202.859375,
        strokeColor: '#495057',
        backgroundColor: 'transparent',
        width: 129.3203125,
        height: 2.37109375,
        seed: 1916218657,
        groupIds: [],
        points: [
          [0, 0],
          [129.3203125, -2.37109375],
        ],
        lastCommittedPoint: null,
      },
      {
        type: 'text',
        version: 251,
        versionNonce: 372868120,
        isDeleted: false,
        id: 'wtb4Yribw-nAtL08vZ23e',
        fillStyle: 'hachure',
        strokeWidth: 1,
        strokeStyle: 'solid',
        roughness: 1,
        opacity: 100,
        angle: 0,
        x: 897.15234375,
        y: 178.375,
        strokeColor: '#495057',
        backgroundColor: 'transparent',
        width: 103,
        height: 50,
        seed: 1335127553,
        groupIds: [],
        fontSize: 20,
        fontFamily: 1,
        text: 'Your slides\nare here',
        baseline: 43,
        textAlign: 'center',
        verticalAlign: 'top',
      },
      {
        type: 'arrow',
        version: 239,
        versionNonce: 1006099816,
        isDeleted: false,
        id: 'Lb75dGY-eyDv_Ggzu-NYK',
        fillStyle: 'hachure',
        strokeWidth: 1,
        strokeStyle: 'solid',
        roughness: 1,
        opacity: 100,
        angle: 0,
        x: 783.7421875,
        y: 450.35546875,
        strokeColor: '#495057',
        backgroundColor: 'transparent',
        width: 1.33984375,
        height: 86.46875,
        seed: 1173279553,
        groupIds: [],
        points: [
          [0, 0],
          [1.33984375, 86.46875],
        ],
        lastCommittedPoint: null,
      },
      {
        type: 'text',
        version: 378,
        versionNonce: 101518616,
        isDeleted: false,
        id: 'SuI5Qmp3bo2jBHUQspdKo',
        fillStyle: 'hachure',
        strokeWidth: 1,
        strokeStyle: 'solid',
        roughness: 1,
        opacity: 100,
        angle: 0,
        x: 624.8125,
        y: 411.55859375,
        strokeColor: '#495057',
        backgroundColor: 'transparent',
        width: 305,
        height: 25,
        seed: 1678685121,
        groupIds: [],
        fontSize: 20,
        fontFamily: 1,
        text: 'Switch between view/edit modes',
        baseline: 18,
        textAlign: 'center',
        verticalAlign: 'top',
      },
      {
        type: 'rectangle',
        version: 168,
        versionNonce: 887159912,
        isDeleted: false,
        id: 'KUKawcbNTup3jmX3yndJz',
        fillStyle: 'hachure',
        strokeWidth: 1,
        strokeStyle: 'solid',
        roughness: 1,
        opacity: 100,
        angle: 0,
        x: 848.96484375,
        y: 161.390625,
        strokeColor: '#495057',
        backgroundColor: '#ced4da',
        width: 32.3046875,
        height: 23.9453125,
        seed: 33251864,
        groupIds: [],
      },
      {
        type: 'rectangle',
        version: 203,
        versionNonce: 1124687384,
        isDeleted: false,
        id: 'quT-6n1jyvD_gZQIcq2TB',
        fillStyle: 'hachure',
        strokeWidth: 1,
        strokeStyle: 'solid',
        roughness: 1,
        opacity: 100,
        angle: 0,
        x: 848.703125,
        y: 189.76953125,
        strokeColor: '#495057',
        backgroundColor: '#ced4da',
        width: 32.3046875,
        height: 23.9453125,
        seed: 37507352,
        groupIds: [],
      },
      {
        type: 'rectangle',
        version: 205,
        versionNonce: 1398091624,
        isDeleted: false,
        id: 'qbpX_c1FMldDEzT-kGrjX',
        fillStyle: 'hachure',
        strokeWidth: 1,
        strokeStyle: 'solid',
        roughness: 1,
        opacity: 100,
        angle: 0,
        x: 847.8046875,
        y: 217.296875,
        strokeColor: '#495057',
        backgroundColor: '#ced4da',
        width: 32.3046875,
        height: 23.9453125,
        seed: 688333416,
        groupIds: [],
      },
      {
        type: 'rectangle',
        version: 606,
        versionNonce: 1994911848,
        isDeleted: false,
        id: '_C5e0MxLTdfb5YxglDP04',
        fillStyle: 'hachure',
        strokeWidth: 1,
        strokeStyle: 'solid',
        roughness: 1,
        opacity: 100,
        angle: 0,
        x: 715.5078125,
        y: 321.7382812499999,
        strokeColor: '#495057',
        backgroundColor: '#ced4da',
        width: 31.3046875,
        height: 30.38671875,
        seed: 1378534248,
        groupIds: [],
      },
      {
        type: 'text',
        version: 570,
        versionNonce: 1075554840,
        isDeleted: false,
        id: 'Ow1KVkle6EGIKW-HlZuuL',
        fillStyle: 'hachure',
        strokeWidth: 1,
        strokeStyle: 'solid',
        roughness: 1,
        opacity: 100,
        angle: 0,
        x: 722.16015625,
        y: 323.9316406249999,
        strokeColor: '#495057',
        backgroundColor: '#ced4da',
        width: 18,
        height: 26,
        seed: 440033128,
        groupIds: [],
        fontSize: 20,
        fontFamily: 1,
        text: '▶',
        baseline: 19,
        textAlign: 'center',
        verticalAlign: 'middle',
      },
      {
        type: 'rectangle',
        version: 744,
        versionNonce: 543007592,
        isDeleted: false,
        id: 'M6jTHgPM3-fSQjNxFb2-r',
        fillStyle: 'hachure',
        strokeWidth: 1,
        strokeStyle: 'solid',
        roughness: 1,
        opacity: 100,
        angle: 0,
        x: 806.40234375,
        y: 320.5839843749999,
        strokeColor: '#495057',
        backgroundColor: '#ced4da',
        width: 31.3046875,
        height: 30.38671875,
        seed: 2039833112,
        groupIds: [],
      },
      {
        type: 'text',
        version: 684,
        versionNonce: 1481549592,
        isDeleted: false,
        id: 'vRA4EYkqBO9qSdpoPB4Ca',
        fillStyle: 'hachure',
        strokeWidth: 1,
        strokeStyle: 'solid',
        roughness: 1,
        opacity: 100,
        angle: 0,
        x: 814.0546875,
        y: 322.7773437499999,
        strokeColor: '#495057',
        backgroundColor: '#ced4da',
        width: 16,
        height: 26,
        seed: 1037733736,
        groupIds: [],
        fontSize: 20,
        fontFamily: 1,
        text: '✎',
        baseline: 19,
        textAlign: 'center',
        verticalAlign: 'middle',
      },
      {
        type: 'arrow',
        version: 1444,
        versionNonce: 379909736,
        isDeleted: false,
        id: 'LWpNQuYH2OaabYsQNn7EK',
        fillStyle: 'hachure',
        strokeWidth: 1,
        strokeStyle: 'solid',
        roughness: 1,
        opacity: 100,
        angle: 0,
        x: 814.1367187500009,
        y: 314.9597313214964,
        strokeColor: '#495057',
        backgroundColor: '#ced4da',
        width: 54.902343749999076,
        height: 28.57542492850345,
        seed: 980215912,
        groupIds: [],
        points: [
          [-8.558593750000925, -8.151567158176476],
          [-36.03680112604685, -33.71484375],
          [-63.4609375, -5.139418821496553],
        ],
        lastCommittedPoint: null,
      },
      {
        type: 'arrow',
        version: 1655,
        versionNonce: 1259996184,
        isDeleted: false,
        id: '5Qs8MHSFZHIBkUwBO9s3p',
        fillStyle: 'hachure',
        strokeWidth: 1,
        strokeStyle: 'solid',
        roughness: 1,
        opacity: 100,
        angle: 3.141592653589793,
        x: 813.3964843750005,
        y: 397.60681878574826,
        strokeColor: '#495057',
        backgroundColor: '#ced4da',
        width: 54.902343749999076,
        height: 28.57542492850345,
        seed: 465678184,
        groupIds: [],
        points: [
          [-8.558593750000925, -8.151567158176476],
          [-36.03680112604685, -33.71484375],
          [-63.4609375, -5.139418821496553],
        ],
        lastCommittedPoint: null,
      },
    ],
  },
]
